import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { AMENITIES_OPTIONS, PROPERTY_FEATURES } from "@/data/propertyFormConstants";

/**
 * Amenities & Features Tab Component
 * Handles selection of property amenities and features
 */
const AmenitiesTab = ({ 
  formData, 
  onAmenityToggle, 
  onFeatureToggle 
}) => {
  return (
    <div className="space-y-6">
      {/* Amenities Section */}
      <div>
        <Label className="text-lg font-semibold mb-4 block">Amenities</Label>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {AMENITIES_OPTIONS.map(amenity => (
            <div key={amenity} className="flex items-center space-x-2">
              <Checkbox
                id={`amenity-${amenity}`}
                checked={formData.amenities?.includes(amenity) || false}
                onCheckedChange={() => onAmenityToggle(amenity)}
                data-testid={`amenity-${amenity.replace(/\s+/g, '-').toLowerCase()}`}
              />
              <Label 
                htmlFor={`amenity-${amenity}`} 
                className="cursor-pointer text-sm"
              >
                {amenity}
              </Label>
            </div>
          ))}
        </div>
      </div>

      {/* Property Features Section */}
      <div>
        <Label className="text-lg font-semibold mb-4 block">Property Features</Label>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {PROPERTY_FEATURES.map(feature => (
            <div key={feature} className="flex items-center space-x-2">
              <Checkbox
                id={`feature-${feature}`}
                checked={formData.property_features?.includes(feature) || false}
                onCheckedChange={() => onFeatureToggle(feature)}
                data-testid={`feature-${feature.replace(/\s+/g, '-').toLowerCase()}`}
              />
              <Label 
                htmlFor={`feature-${feature}`} 
                className="cursor-pointer text-sm"
              >
                {feature}
              </Label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AmenitiesTab;
